import React, { useState } from 'react';
import styles from './Updates.module.css';

import { FaArrowRight } from "react-icons/fa6";

import Button from '../button/Button';
import Icon from '../icon/Icon';

import emailjs from '@emailjs/browser';

const Updates = () => {

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!email) {
      alert("Enter email first ❌");
      return;
    }

    setLoading(true);

    emailjs.send(
      "service_l2r4tkr",      // ✅ same service ID
      "template_4rdohbj",   // 🔥 NEW TEMPLATE ID (banani padegi)
      {
        user_email: email,    // 👈 ye template me same hona chahiye
      },
      "ZTKYWdIvUSrBslRtW"
    )
    .then(() => {
      alert("Subscribed ✅");
      setEmail("");
      setLoading(false);
    })
    .catch((err) => {
      console.error(err);
      alert("Failed ❌");
      setLoading(false);
    });
  };

  return (
    <div className={styles.parent}>
      <h3>Get the Latest <span>Updates</span></h3>
      <p>Subscribe to stay updated with our latest drinks, news, and special announcements.</p>

      <div className={styles.main}>
        <input
          type="email"
          placeholder="Enter Your Email"
          className={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <div style={{ display: "flex" }}>
          <Button 
            text={loading ? "Sending..." : "Subscribe"} 
            onClick={handleSubmit} 
          />
          <Icon Icon={FaArrowRight} />
        </div>
      </div>
    </div>
  )
}

export default Updates;




// import React from 'react';
// import styles from './Updates.module.css';


// import { FaArrowRight } from "react-icons/fa6";

// import Button from '../button/Button';
// import Icon from '../icon/Icon';

// const Updates = () => {
//     return (
//         <div className={styles.parent}>
//             <h3>Get the Latest <span>Updates</span></h3>
//             <p>Subscribe to stay updated with our latest drinks, news, and special announcements.</p>
//             <div className={styles.main}>
//                 <input
//                     type="text"
//                     placeholder="Enter Your Email"
//                     className={styles.input}
//                 />
//                 <div style={{display: "flex"}}>
//                 <Button text="subscribe" />
//                 <Icon Icon={FaArrowRight} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Updates;